'use client'

import type { ArticleTeaserProps } from '@maestro/commerce-blocks/components/article-teaser/article-teaser.types'

import { useTranslations } from 'next-intl'
import React from 'react'

import { useArticleTeaser } from '@maestro/commerce-blocks/components/article-teaser/batons/use-article-teaser'
import { isValidImageElement } from '@maestro/commerce-blocks/utils/image.utils'
import { Link } from '@pearlconvert/ui/components/link'

import '@maestro/commerce-blocks/components/article-teaser/styles/article-teaser.scss'

export default function ArticleTeaser(props: ArticleTeaserProps) {
  const {
    image,
    title,
    description,
    url,
    showReadMore = true,
    headerTag = 'h3',
    ariaHidden = 'false',
    onClick,
  } = props
  const t = useTranslations('commerce-blocks')
  const { onReadMoreClick } = useArticleTeaser(props)
  const isValidImage = isValidImageElement(image)

  const HeaderTag = headerTag

  return (
    <Link href={url} className="article-teaser" onClick={onClick}>
      {isValidImage && (
        <div className="article-teaser__image-wrapper" aria-hidden="true">
          {image}
        </div>
      )}
      <HeaderTag
        className="article-teaser__title"
        title={title}
        aria-hidden={ariaHidden}
      >
        {title}
      </HeaderTag>

      {description && (
        <p className="article-teaser__description" aria-hidden={ariaHidden}>
          {description}
        </p>
      )}
      {showReadMore && (
        <span
          className="article-teaser__read-more"
          aria-hidden="true"
          onClick={onReadMoreClick}
        >
          {t('_globals.read-more')}
        </span>
      )}
    </Link>
  )
}
